import React from 'react';
import { Instagram, ArrowUpRight, Lock } from 'lucide-react';
import { BRAND, NAV, WHATSAPP_LINK, MARQUEE } from '../data/mock';

export default function Footer() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <footer className="relative pt-16 md:pt-20 pb-10 border-t border-white/8 overflow-hidden">
      {/* Marquee */}
      <div className="py-6 md:py-8 border-y border-white/8 mb-12 md:mb-20 overflow-hidden">
        <div className="flex animate-marquee-rev whitespace-nowrap">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-10 px-5">
              <span className="font-display-tight text-[24px] md:text-[36px] leading-none text-[#F5F1E8]/30 hover:text-[#C8FF61] transition-colors duration-500">{item}</span>
              <span className="font-serif-italic text-[24px] md:text-[36px] text-[#F5F1E8]/15">/</span>
            </div>
          ))}
        </div>
      </div>

      <div className="thesis-container">
        <div className="reveal border-b border-white/8 pb-10 md:pb-14">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div className="flex items-end gap-2" translate="no">
              <h2 className="font-display-tight text-[80px] md:text-[200px] leading-[0.85] text-[#F5F1E8]">
                {BRAND.name}
              </h2>
              <span className="font-serif-italic text-[#C8FF61] text-[44px] md:text-[100px] leading-none -mb-2 md:-mb-5">°</span>
            </div>
            <a href={WHATSAPP_LINK()} target="_blank" rel="noopener noreferrer"
              className="cursor-hover inline-flex items-center gap-2 bg-[#C8FF61] text-[#0A0B0E] hover:bg-[#F5F1E8] px-6 py-3.5 rounded-full text-[14px] font-semibold transition-colors duration-300">
              Vamos conversar <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="py-10 md:py-14 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <span className="font-mono-label text-[#8E8B85]">// SOBRE</span>
            <p className="mt-4 text-[15px] leading-relaxed text-[#F5F1E8]/80 max-w-[340px]">
              {BRAND.name} é um estúdio de marketing digital de {BRAND.city}. Trabalhamos com marcas que querem crescer sem queimar orçamento.
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-label text-[#8E8B85]">// NAVEGAÇÃO</span>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="line-link text-[15px] text-[#F5F1E8] cursor-hover">{n.label}</a>
                </li>
              ))}
              <li><a href="#contato" className="line-link text-[15px] text-[#F5F1E8] cursor-hover">Contato</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-label text-[#8E8B85]">// CONTATO</span>
            <ul className="mt-4 space-y-2.5 text-[15px] text-[#F5F1E8]">
              <li>{BRAND.phoneFormatted}</li>
              <li>{BRAND.email}</li>
              <li className="text-[#8E8B85]">{BRAND.city} · {BRAND.region}</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <span className="font-mono-label text-[#8E8B85]">// REDES</span>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="line-link inline-flex items-center gap-2 text-[15px] text-[#F5F1E8] cursor-hover">
                  <Instagram size={14} /> {BRAND.instagram}
                </a>
              </li>
              <li>
                <a href={WHATSAPP_LINK()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="line-link text-[15px] text-[#F5F1E8] cursor-hover">WhatsApp</a>
              </li>
              <li>
                <a href="/admin/login" data-testid="footer-admin-link" className="line-link inline-flex items-center gap-2 text-[13px] text-[#8E8B85] cursor-hover hover:text-[#C8FF61] transition-colors">
                  <Lock size={12} /> Admin
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/8 flex flex-wrap items-center justify-between gap-4 text-[12px] font-mono-label text-[#8E8B85]">
          <span>© {new Date().getFullYear()} {BRAND.name}. TODOS OS DIREITOS RESERVADOS.</span>
          <span>FEITO COM CUIDADO EM {BRAND.city.toUpperCase()}</span>
        </div>
      </div>
    </footer>
  );
}
